<template>
  <div>
    <sidepanel
      id="panel-client-tests"
      @open="init"
      @close="close"
      :processing="processing"
      :title="clientName"
    >
      <button @click="addPanel('panel-kits')" class="primary">
        Add test (select kit)
      </button>
      <div id="test-list">
        <div
          v-for="(testKit, index) in tests"
          :key="'test-' + index"
          @click="addPanel('panel-view-test', { testId: testKit.id })"
          class="client-test"
        >
          <div>
            <strong>{{ testKit.kit.name }}</strong>
          </div>
          <div>Created: {{ testKit.created | date }}</div>
          <div>
            <TestStatus :status="testKit.status" />
          </div>
        </div>
      </div>
    </sidepanel>
    <PanelKits @select="addKit" />
    <PanelViewTest :prevPanelInit="init" />
  </div>
</template>

<script>
import PanelKits from "./PanelKits";
import PanelViewTest from "@/components/PanelViewTest";
import TestStatus from "@/components/TestStatus";

export default {
  data() {
    return {
      client: null,
      clientName: "",
      clientId: null,
      processing: false,
      tests: []
    };
  },
  components: {
    PanelKits,
    PanelViewTest,
    TestStatus
  },
  methods: {
    async addKit(kit) {
      this.processing = true;
      await this.$store.dispatch("TestsStore/addToClient", {
        kit,
        clientId: this.clientId
      });
      this.init();
    },
    async init() {
      this.processing = true;
      const { clientName, clientId } = this.$store.getters.sidepanel(
        "panel-client-tests"
      ).payload;
      this.clientName = clientName;
      this.clientId = clientId;
      const clientTests = await this.$store.dispatch(
        "TestsStore/getByClient",
        clientId
      );
      this.tests = clientTests.sort((a, b) => b.updated - a.updated);
      this.processing = false;
    },
    close() {
      this.client = null;
      this.tests = [];
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/vars";
.client-test {
  cursor: pointer;
  padding: @h1;
  &:hover {
    background-color: #ffffcc;
  }
  & + .client-test {
    border-top: 1px solid #eee;
  }
}

#test-list {
  margin-top: @h1;
}
</style>
